const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

export async function fetchAiUsageCostOverview({ fromDate, toDate, tenantAdminUserId, tenantId } = {}) {
  const params = new URLSearchParams();
  if (fromDate) {
    params.set('fromDate', fromDate);
  }
  if (toDate) {
    params.set('toDate', toDate);
  }
  if (tenantAdminUserId) {
    params.set('tenantAdminUserId', String(tenantAdminUserId));
  }
  if (tenantId) {
    params.set('tenantId', String(tenantId));
  }
  const query = params.toString();
  const response = await fetch(`${API_BASE}/api/system/ai-usage-costs${query ? `?${query}` : ''}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'AI kullanim ve maliyet verileri alinamadi.');
}

const systemAiUsageCostsService = {
  fetchAiUsageCostOverview
};

export default systemAiUsageCostsService;
